import React from 'react';
import styled from 'styled-components';

import {contactsLearnMoreUrl} from '../../../../../../../../src/helpers/contactsManagerHelpers';
import {openInBrowser} from '../../../../../../../../srcCommon/browser/openInBrowser';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {InfoBox} from './infoBox';

/*
 * Styles.
 */

const StyledInfoBoxWrapperDiv = styled.div`
  padding: 15px 53px 24px 0px;
  background: ${(p) => p.theme.foreground};
  margin-left: -12px;
`;

const StyledParagraph = styled.p`
  margin-top: 5px;
  margin-bottom: 0;
  &:nth-of-type(1) {
    margin-top: 0;
  }
`;

/*
 * Component.
 */

export const AutoContactsInfoBoxes = () => {
  const onLearnMoreClick = () => openInBrowser(contactsLearnMoreUrl);

  return (
    <StyledInfoBoxWrapperDiv>
      <InfoBox
        title={<Trans id="auto-contacts-infobox-title">What are auto-created contacts?</Trans>}
        footer={<Trans id="auto-contacts-infobox-learn-more-link">Learn more</Trans>}
        onFooterClick={onLearnMoreClick}
      >
        <StyledParagraph>
          <Trans id="auto-contacts-infobox-body-1">
            When someone reaches out to you or to an inbox you have access to, their contact information will
            be added to this list automatically.
          </Trans>
        </StyledParagraph>
        <StyledParagraph>
          <Trans id="auto-contacts-infobox-body-2">
            Only teammates who have access to conversations with those contacts will have access to their
            information.
          </Trans>
        </StyledParagraph>
      </InfoBox>
    </StyledInfoBoxWrapperDiv>
  );
};
